
    import "/home/git/waysglob/website/src/components/news-events-item/index.module.scss.FARM_CSS_MODULES?70ecd605";
    
    export default {"title": `title-fb74e3ba`,"card": `card-fb74e3ba`,"image": `image-fb74e3ba`,"time": `time-fb74e3ba`}
    